import { __makeTemplateObject } from '../../_externals/.pnpm/tslib@2.7.0/node_modules/tslib/tslib.es6.js';
import { keyframes } from '@emotion/react';
import tokens from '@lacedltd/design-tokens';

var shimmerAnimation = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n"], ["\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n"])));
var skeletonLoadingImage = {
    boxSizing: "border-box",
    position: "relative",
    backgroundColor: tokens.color.airJordan[50],
    overflow: "hidden",
    height: "100%",
    "&:after": {
        content: '""',
        display: "block",
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        background: "linear-gradient(90deg, rgba(231, 232, 233, 0) 0%, rgba(238, 239, 241, 0.7) 34.57%, rgba(238, 239, 241, 0.7) 75%, rgba(231, 232, 233, 0) 100%)",
        transform: "translateX(100%)",
        animation: "".concat(shimmerAnimation, " 2s infinite"),
    },
};
var templateObject_1;

export { shimmerAnimation, skeletonLoadingImage };
//# sourceMappingURL=animation.js.map
